import { getMostVisible } from "../utils";

export default class {
	constructor(options) {
		this.menu = document.querySelector(".category-menu");

		if (!this.menu) {
			return;
		}

		this.options = options;
		this.disabled = false;

		this.initMenu();
	}

	initMenu() {
		this.adminbar = document.getElementById("wpadminbar");
		this.currentItem = this.menu.querySelector(".current-item");
		this.menuList = this.menu.querySelector("ul");
		this.menuItems = this.menu.querySelectorAll("li");
		this.siteHeader = document.querySelector("header.site-header");
		this.sections = document.querySelectorAll("section.product-category");

		this.visibleSection = this.sections.item(0);

		this.currentItem.addEventListener("click", this.toggleMenu.bind(this));
		document.addEventListener("click", this.handleMenuClose.bind(this));
		window.addEventListener("scroll", this.adjustMenuPosition.bind(this));
		window.addEventListener("scroll", this.observeSectionVisibility.bind(this));
		window.addEventListener("resize", this.setMenuListHeight.bind(this));
		this.menuList.addEventListener("click", this.handleMenuClick.bind(this));

		this.selectItem(this.menuItems.item(0));

		this.scrollObserveDisabled = false;
		this.timeout = false;
	}

	selectItem(item) {
		if (item) {
			this.currentItem.innerText = item.innerText;
		}
	}

	isOpen() {
		return this.menu.classList.contains("is-visible");
	}

	openMenu() {
		this.setMenuListHeight();
		this.menu.classList.add("is-visible");
	}

	closeMenu() {
		this.menu.classList.remove("is-visible");
	}

	toggleMenu(e) {
		e.preventDefault();

		if (this.isOpen()) {
			this.closeMenu();
		} else {
			this.openMenu();
		}
	}

	handleMenuClose(e) {
		return (
			this.isOpen() &&
			(!e.target.parentNode.isSameNode(this.menu) ||
				"A" !== e.target.tagName ||
				!e.target.classList.contains("current-item")) &&
			this.closeMenu()
		);
	}

	handleMenuClick(e) {
		this.setScrollTimeout();
		this.scrollObserveDisabled = true;
		this.selectItem(e.target);
	}

	enableScrollObserve() {
		this.scrollObserveDisabled = false;
	}

	setScrollTimeout() {
		clearTimeout(this.timeout);
		this.timeout = setTimeout(this.enableScrollObserve.bind(this), 100);
	}

	setMenuListHeight() {
		const listStyle = window.getComputedStyle(this.menuList);
		const listHeight =
			window.innerHeight -
			this.menu.getBoundingClientRect().top -
			this.currentItem.offsetHeight -
			parseInt(listStyle.marginTop) -
			parseInt(listStyle.marginBottom);

		this.menuList.style.maxHeight = `${listHeight}px`;
	}

	adjustMenuPosition() {
		let offset = 0;

		if (this.siteHeader) {
			offset =
				("fixed" === window.getComputedStyle(this.siteHeader).position
					? 0
					: this.siteHeader.offsetHeight) +
				(this.adminbar &&
				"absolute" === window.getComputedStyle(this.adminbar).position
					? this.adminbar.offsetHeight
					: 0);
		}

		if (window.scrollY > offset && !this.menu.classList.contains("is-fixed")) {
			this.menu.classList.add("is-fixed");
		} else if (
			window.scrollY <= offset &&
			this.menu.classList.contains("is-fixed")
		) {
			this.menu.classList.remove("is-fixed");
		}

		if (this.isOpen() && !this.menu.classList.contains("is-fixed")) {
			this.setMenuListHeight();
		}
	}

	disable() {
		this.scrollObserveDisabled = true;
	}

	observeSectionVisibility() {
		if (true === this.scrollObserveDisabled) {
			this.setScrollTimeout();
			return;
		}

		const section = getMostVisible(this.sections);

		if (section && !section.isSameNode(this.visibleSection)) {
			this.visibleSection = section;

			const id = section.getAttribute("id");
			const link = this.menuList.querySelector(`a[href=\"\#${id}\"]`);

			section.removeAttribute("id");

			if ("function" === typeof this.options.onHashChange) {
				this.options.onHashChange(id);
			} else {
				window.location.hash = id;
			}

			this.selectItem(link);
			section.setAttribute("id", id);
		}
	}
}
